import React, { useEffect, useState } from 'react'
import { Box, TextField, Tooltip, Typography, Autocomplete, Button, Drawer, Stack } from '@mui/material'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { DateTime } from "luxon";
import { localGetItem } from '../../../Utility/Services/CacheProviderService'
import { formatDate } from '../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../Utility/ImagePaths'
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'

export default function MRDAuditTrack() {
    const [TrackData, setTrackData] = useState([]);
    const [LocationList, setLocationList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [Filter, setFilter] = useState({
        openFilter: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
        uhid: '',
        location: null
    });


    useEffect(() => {
        getDrugMaster()
        getLocationList()
    }, [])

    const getDrugMaster = (clear) => {
        try {
            setisloader(true)
            let URL = clear ? Serviceurls.MRD_DOC_TRACKER + `?patient_uhid=${''}&live_location=${""}&live_location_name=${''}&from_date=${DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')}&to_date=${DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')}` :
                Serviceurls.MRD_DOC_TRACKER + `?patient_uhid=${Filter?.uhid || ''}&live_location=${(Filter?.location?.type !== 'MRD' && Filter?.location?.type) ? (Filter?.location?.id || '') : ""}&live_location_name=${Filter?.location?.type === 'MRD' ? 'MRD' : ''}&from_date=${Filter?.fromDate}&to_date=${Filter?.toDate}`;
            RestAPIService.getAll(URL)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setTrackData(response?.data?.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getLocationList = () => {
        let Docdetail = JSON.parse(localGetItem("loggedInUserInfo"))
        const ClinicID = Docdetail?.clinic_id || JSON.parse(localGetItem("SelectedDoctorClinicId"))
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.MRD_ROOMS_LIST + `?clinic_id=${ClinicID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setLocationList(response?.data?.data)
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const closeFilter = () => {
        setFilter(prev => ({ ...prev, openFilter: false }));
    }

    const FilterDate = (fromDate, toDate, dateIndex) => {
        setFilter(prev => ({
            ...prev,
            fromDate: fromDate,
            toDate: toDate,
            dateIndex: dateIndex
        }));
    }

    const renderFilterScreen = () => {
        return (
            <Box component="div" className='eMed_rts_filter_container'>
                <Box component="div" className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{('Filter')}</Typography>
                    <Button
                        emed_tid="vndpay_close"
                        onClick={() => setFilter(prev => ({ ...prev, openFilter: false }))}
                        className='eMed_usrconf_btn'
                    >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>

                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter_vendor'>
                        <CommonDatePicker
                            FromDate={Filter.fromDate}
                            ToDate={Filter.toDate}
                            DateIndex={Filter.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={false}
                        />
                    </Box>
                    {textBox("Search UHID", 'uhid', Filter.uhid, null)}
                    {textBox("Current Location", 'location', Filter.location, LocationList)}
                </Box>
                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button
                        variant='outlined'
                        size="small"
                        emed_tid="fil_clear"
                        onClick={() => {
                            setFilter(prev => ({
                                ...prev,
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                uhid: '',
                                location: null
                            }));
                            setTimeout(() => {
                                getDrugMaster(true);
                            }, 500);
                        }}
                        id="eMed_Config_btn"
                    >
                        {("Clear")}
                    </Button>
                    <Button
                        variant='contained'
                        size="small"
                        emed_tid="fil_search"
                        onClick={() => {
                            getDrugMaster();
                            setFilter(prev => ({ ...prev, openFilter: false }));
                        }}
                        id="eMed_Config_btn"
                    >
                        {("Search")}
                    </Button>
                </Stack>
            </Box>
        );
    };

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(Filter.fromDate) },
            { label: "To Date", value: formatDate(Filter.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>
        )
    }

    const textBox = (label, name, val, list) => {
        return (
            <Box>
                {name === 'location' ?
                    <Autocomplete
                        size={'small'}
                        options={list}
                        name={name}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.name}
                        value={val}
                        sx={{ width: '100%', marginTop: "0.5vw" }}
                        onChange={(event, newValue) => {
                            setFilter({ ...Filter, [name]: newValue })
                        }}
                        renderInput={(params) => <TextField {...params} label={label} />}
                    />
                    : <TextField
                        size='small'
                        name={name}
                        id="uhid-search"
                        value={val}
                        sx={{ width: '100%', marginRight: '1vw' }}
                        label={label}
                        onChange={(e) => {
                            if (name === 'uhid') {
                                setFilter({ ...Filter, [name]: e.target.value })
                            }
                        }}
                        variant="outlined"
                    />
                }
            </Box>
        )
    }

    const tableView = () => {

        TrackData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'patient_uhid', headerName: 'UHID', flex: 0.125,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_uhid ? params?.row?.patient_uhid : '-'}</Box>)
            },
            {
                field: 'transfer_date', headerName: 'Date & Time', flex: 0.125, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params.row.transfer_date
                    ? DateTime.fromFormat(params.row.transfer_date, "yyyy-MM-dd HH:mm").toFormat("dd-MM-yyyy hh:mm a")
                    : "-"}</Box>)
            },
            {
                field: 'live_location_name', headerName: 'Current Location', flex: 0.13,
                renderCell: (params) => (params.row.live_location_name ? params.row.live_location_name?.length > 30 ?
                    <Tooltip placement="top" title={params.row.live_location_name}><Typography fontSize={'1vw'}>{params.row.live_location_name?.slice(0, 27) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'1vw'}>{params.row.live_location_name}</Typography> : '-')
            },
            // {
            //     field: 'category', headerName: 'Category', flex: 0.13,
            //     renderCell: (params) => (params.row.category ? params.row.category?.length > 15 ?
            //         <Tooltip placement="top" title={params.row.category}><Typography fontSize={'1vw'}>{params.row.category?.slice(0, 15) + '...'}</Typography></Tooltip> :
            //         <Typography fontSize={'1vw'}>{params.row.category}</Typography> : '-')
            // },
            // {
            //     field: 'dosage_type', headerName: 'Last Visit Date', flex: 0.125,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.dosage_type ? params?.row?.dosage_type : '-'}</Box>)
            // },
            // {
            //     field: 'drug_strength', headerName: 'Version No', flex: 0.10,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.drug_strength ? params?.row?.drug_strength : '-'}</Box>)
            // },
            {
                field: "location_from", headerName: "From Details", flex: 0.14,
                valueGetter: (params) => {
                    const loc = params?.row?.location_from;
                    if (!loc) return "";
                    return `${loc?.name || ""} ${loc?.type || ""}`.trim();
                },
                renderCell: (params) => {
                    const loc = params?.row?.location_from;
                    return (
                        <Box component={'div'}>
                            {loc ? (
                                <Box>
                                    <Typography fontSize={'0.85vw'}>
                                        {loc?.name || '-'}
                                    </Typography>
                                    <Typography fontWeight={600} textTransform={'capitalize'} fontSize={'0.8vw'}>
                                        {loc?.type || '-'}
                                    </Typography>
                                </Box>
                            ) : "-"}
                        </Box>
                    );
                }
            },
            {
                field: "location_to", headerName: "To Details", flex: 0.14,
                valueGetter: (params) => {
                    const loc = params?.row?.location_to;
                    if (!loc) return "";
                    return `${loc?.name || ""} ${loc?.type || ""}`.trim();
                },
                renderCell: (params) => {
                    const loc = params?.row?.location_to;
                    return (
                        <Box component={'div'}>
                            {loc ? (
                                <Box>
                                    <Typography fontSize={'0.85vw'}>
                                        {loc?.name || '-'}
                                    </Typography>
                                    <Typography fontWeight={600} textTransform={'capitalize'} fontSize={'0.8vw'}>
                                        {loc?.type || '-'}
                                    </Typography>
                                </Box>
                            ) : "-"}
                        </Box>
                    );
                }
            },
            {
                field: 'status', headerName: 'Status', flex: 0.10,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.status ? params?.row?.status : '-'}</Box>)
            }
        ]
        return (
            <Box sx={{ height: '69vh' }}>
                <DataGrid
                    rows={TrackData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const errorMessage = (msg) => {
        seterrorMsg(true)
        seterrorMsgText(msg)
    }
    const successMessage = (msg) => {
        setsuccessMsg(true)
        setsuccessMsgText(msg)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '7vh', width: '93vw', backgroundColor: 'white', padding: '1vw' }}>
                {/* <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Box>
                        {textBox("Search UHID", 'uhid', trackStates.uhid, null, '14vw')}
                        {textBox("Current Location", 'location', trackStates.location, LocationList, '14vw')}
                        <Button
                            size="small"
                            className="Common_Btn_Min_Width"
                            sx={{ textTransform: "capitalize", height: "2.3vw", width: "5vw" }}
                            variant='contained'
                            onClick={() => getDrugMaster(false)}
                        >
                            search
                        </Button>
                        <Button
                            size="small"
                            className="Common_Btn_Min_Width"
                            sx={{ textTransform: "capitalize", height: "2.4vw", marginLeft: "0.5vw", width: "5vw" }}
                            variant='outlined'
                            onClick={() => getDrugMaster(true)}
                        >
                            clear
                        </Button>
                    </Box>
                </Box> */}
                <Box flex={0.2} display="flex" justifyContent="flex-end" alignItems="center" marginRight="0.5vw">
                    <Tooltip title="Filter" placement='top' arrow>
                        <Button className='eMed_usrconf_btn' onClick={() => { setFilter(prev => ({ ...prev, openFilter: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '69vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={Filter.openFilter}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    )
}
